module.exports = __webpack_public_path__ + "img/logo.879b2742.png";